<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        Button, EmbedVideo, Heading, Paragraph, Small, openModal,
    } from '@smatch/cassiopeia-web-components';

    // STORES
    import { SKIP } from '../../store';

    /* INTERNALS ------------------------------------------------------------------------------- */

    const skipLogistics = (): void => {
        $SKIP.hasLogistics = true;
        openModal('#onboarding');
    };


</script>

<div class = 's8-wrap'>

    <Heading size = 'md'>Discover smatch Delivery & Warehouse Solutions</Heading>

    <EmbedVideo source = 'https://www.loom.com/embed/c0b3a3d2858d4c32848eebd147d5b861' css = 'mb-5' />

    <Paragraph>
        smatch takes care of your delivery and warehouse needs, customizing logistics to
        fit your specifications. Just let us know where to ship, and we'll handle the rest.
    </Paragraph>

    <Paragraph>
        We offer pick-up from the seller's warehouse within 24 hours, secure handling,
        real-time tracking, export services, and other tailored solutions to meet your needs.
    </Paragraph>

    <Paragraph>
        Share your requirements with us, and we'll manage the entire process for you.
    </Paragraph>

    <div class = 's8-footer'>

        <div>

            <Button
                type = 'button'
                label = 'Not Interested'
                color = 'neutral'
                css = 'w-full'
                on:click = { skipLogistics }
            />

        </div>

        <div>

            <Button
                type = 'submit'
                label = 'Sign Up'
                css = 'w-full'
                url = '#onboarding/logistics-form'
            />

            <Small>(no commitment)</Small>

        </div>

    </div>

</div>


<style lang='postcss'>

    div.s8-wrap {
        :global(p) {
            margin-bottom: 20px;
        }

        div.s8-footer {
            display: flex;
            column-gap: 10px;
            flex-grow: 1;
            align-items: flex-end;
            margin-top: 40px;
            align-items: flex-start;

            > div {
                text-align: center;
                flex: 1;
            }
        }
    }

</style>